export const CLASSROOM_PATHS = ['/classroom/invite/pdf/:jwt'] as const
